const labels = {
  QrCode: {
    'Ref: Page title': 'MyBus',
    'Ref: Hi': 'Hei',
    'Ref: Page content body': 'Saapuessasi ja lähtiessäsi muista skannata QR -koodi',
  },
};
export default labels;
